import React, { useState, useEffect } from 'react'
import './index.scss'
import { connect } from 'react-redux'
import { PlusOutlined } from '@ant-design/icons'
import { Radio, Divider, Input, Upload, message, Popover, Form } from 'antd'
import api from '../../../../../services/api'
import ColorPicker from '../../../../../components/ColorPicker'
import { setMixedBlock } from '../../../../../store/actions/index'
import bxlutils from 'bxl-utils'
import legoService from '../../../../../services/lego'
import unit from '@/utils/utils'
import { BASE_LINK } from '@lib/constant'
import { useTranslation } from 'react-i18next'
import { getAuthHeaders } from '@/utils/session'
const FormItem = Form.Item
// interface ItemConfig {
//   imgSrc?: string
//   title1?: string
//   title2?: string
//   enterText?: string
//   bgColor?: string
//   baseLink?: string
//   deepLink?: string
//   color?: string
// }
// interface MixItem {
//   rowNum: number
//   rowType: string
//   item1?: ItemConfig
//   item2?: ItemConfig
//   item3?: ItemConfig
// }
// interface IallConfig {
//   blocks?: MixItem[]
// }
const mapDispatchToProps = dispatch => ({
  editConfig: (id, name, value) => {
    dispatch(setMixedBlock(id, name, value))
  },
})
const mapStateToProps = state => ({
  domain: state.tree.root.config.domain,
  productLink: state.tree.root.config.productLink,
})
// interface IMixedBlocksEditProps {
//   pid?: string
//   id: string
//   config: IallConfig
// }
const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
}

const MixedBlocksEdit = props => {
  const { t } = useTranslation()
  const [currentItem, setCurrentitem] = useState('item1')
  const { config, id, editConfig } = props
  const uploadProps = {
    className: 'avatar-uploader',
    name: 'content',
    action: api.uploadImg,
    showUploadList: false,
    data: {
      format: 'jpg',
      fulldim: '300x300',
      path: 'a.jpg',
    },
    headers: getAuthHeaders() as Record<string, string>,
    beforeUpload: file => {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJPG) {
        message.error('You can only upload JPG/PNG file!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        message.error('Image must smaller than 2MB!')
      }
      uploadProps.data.path = `${unit.generateImgName()}.${file.name.split('.')[1]}`
      return isJPG && isLt2M
    },
  }
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    searchProduct = bxlutils.debounce(500, searchProduct)
  })
  const setConfig = (name, value) => {
    editConfig(id, name, value)
  }
  const uploadImg = (item, e) => {
    const fileStatus = e.file
    const basePath = api.baleenUrl
    if (fileStatus.status === 'done') {
      const imgPath = fileStatus.response.name
      setItem(item, 'imgSrc', `${basePath}/${imgPath}`)
    }
  }
  const setItem = (itemName, name, value) => {
    const item = Object.assign({}, config[itemName] || {})
    item[name] = value
    setConfig(itemName, item)
  }
  const setColor = color => {
    setItem(currentItem, 'bgColor', color)
  }
  let searchProduct = (itemName, product) => {
    if (!product) return
    const { productLink } = props
    legoService
      .getProductImg(product)
      .then(res => {
        const imgUrl = res.data && res.data[0].full.url
        const link = `${
          productLink ? productLink : BASE_LINK.link
        }?utm_source=lego#/product/${product}`
        const deeplink = bxlutils.uri.buildBieyangDeeplink('pdp', {
          productId: product,
        })
        const item = Object.assign({}, config[itemName] || {})
        item.link = link
        item.deepLink = deeplink
        item.imgSrc = imgUrl
        setConfig(itemName, item)
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch(err => {
        message.error(t('productNotFound'))
      })
  }
  const content = (
    <ColorPicker
      handleOk={setColor}
      color={config && config[currentItem] && config[currentItem].bgcolor}
    ></ColorPicker>
  )
  return (
    <div className="form-box">
      <Form>
        <FormItem {...formItemLayout} label={t('columns')}>
          <Radio.Group
            onChange={e => setConfig('rowNum', e.target.value)}
            value={(config && config.rowNum) || 1}
          >
            <Radio value={1}>1</Radio>
            <Radio value={2}>2</Radio>
            <Radio value={3}>3</Radio>
          </Radio.Group>
        </FormItem>
        <FormItem {...formItemLayout} label={t('style')}>
          <Radio.Group
            onChange={e => setConfig('rowType', e.target.value)}
            value={(config && config.rowType) || 'imageBlock'}
          >
            <Radio value={'imageBlock'}>{t('image')}</Radio>
            <Radio value={'bgBlock'}>{t('backgroundImage')}</Radio>
          </Radio.Group>
        </FormItem>
        {new Array((config && config.rowNum) || 1).fill('0').map((el, i) => {
          return (
            <React.Fragment key={`form_${i}`}>
              <Divider></Divider>
              <FormItem {...formItemLayout} label={t('searchById')}>
                <Input
                  className="input-lar-input"
                  type="text"
                  placeholder="product ID"
                  onChange={e => searchProduct(`item${i + 1}`, e.target.value)}
                />
              </FormItem>
              <FormItem {...formItemLayout} label={`${t('image')}(${i + 1})`}>
                <Upload {...uploadProps} onChange={e => uploadImg(`item${i + 1}`, e)}>
                  {config && config[`item${i + 1}`] && config[`item${i + 1}`].imgSrc ? (
                    <img src={config[`item${i + 1}`].imgSrc} alt="" className="avatar imgSrc" />
                  ) : (
                    <PlusOutlined className="avatar-uploader-trigger" />
                  )}
                </Upload>
              </FormItem>
              <FormItem {...formItemLayout} label={`link(${i + 1})`}>
                <Input
                  className="input-lar-input"
                  type="text"
                  placeholder="link"
                  value={config && config[`item${i + 1}`] && config[`item${i + 1}`].link}
                  onChange={e => setItem(`item${i + 1}`, 'link', e.target.value)}
                />
              </FormItem>
              <FormItem {...formItemLayout} label={`deepLink(${i + 1})`}>
                <Input
                  className="input-lar-input"
                  type="text"
                  placeholder="deepLink"
                  value={config && config[`item${i + 1}`] && config[`item${i + 1}`].deepLink}
                  onChange={e => setItem(`item${i + 1}`, 'deepLink', e.target.value)}
                />
              </FormItem>
              {config && config.rowType === 'bgBlock' && (
                <FormItem {...formItemLayout} label={`${t('textTheme')}(${i + 1})`}>
                  <Radio.Group
                    onChange={e => setItem(`item${i + 1}`, 'textModel', e.target.value)}
                    value={
                      (config && config[`item${i + 1}`] && config[`item${i + 1}`].textModel) ||
                      'dark'
                    }
                  >
                    <Radio value={'dark'}>{t('dark')}</Radio>
                    <Radio value={'light'}>{t('light')}</Radio>
                  </Radio.Group>
                </FormItem>
              )}
              <FormItem {...formItemLayout} label={`${t('mixedTitle')}(${i + 1})`}>
                <Input
                  className="input-lar-input"
                  type="text"
                  placeholder={t('mixedTitle')}
                  value={config && config[`item${i + 1}`] && config[`item${i + 1}`].title1}
                  onChange={e => setItem(`item${i + 1}`, 'title1', e.target.value)}
                />
              </FormItem>
              <FormItem {...formItemLayout} label={`${t('subtitle')}(${i + 1})`}>
                <Input
                  className="input-lar-input"
                  type="text"
                  placeholder={t('subtitle')}
                  value={config && config[`item${i + 1}`] && config[`item${i + 1}`].title2}
                  onChange={e => setItem(`item${i + 1}`, 'title2', e.target.value)}
                />
              </FormItem>
              <FormItem {...formItemLayout} label={`${'readMoreButtonText'}(${i + 1})`}>
                <Input
                  className="input-lar-input"
                  type="text"
                  placeholder="马上查看"
                  value={config && config[`item${i + 1}`] && config[`item${i + 1}`].enterText}
                  onChange={e => setItem(`item${i + 1}`, 'enterText', e.target.value)}
                />
              </FormItem>
              {config && config.rowType === 'bgBlock' && (
                <FormItem {...formItemLayout} label={t('backgroundColor')}>
                  <Popover
                    placement="right"
                    title={t('backgroundColor')}
                    content={content}
                    trigger="click"
                  >
                    <div
                      onClick={() => {
                        setCurrentitem(`item${i + 1}`)
                      }}
                      className="colorBtn"
                      style={{
                        background:
                          config && config[`item${i + 1}`] && config[`item${i + 1}`].bgColor,
                      }}
                    ></div>
                  </Popover>
                </FormItem>
              )}
            </React.Fragment>
          )
        })}
      </Form>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(MixedBlocksEdit)
